// extracted by mini-css-extract-plugin
export default {"Button":"StarOption_Button__rajyF","InActive":"StarOption_InActive__G2BVY","Invalid":"StarOption_Invalid__S-PSI"};